var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlarmset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45336 3.29641L5.30592 2.12308C3.38014 3.62462 2.11234 5.93846 2 8.5641H3.60481C3.72518 6.38974 4.81645 4.48615 6.45336 3.29641ZM16.3952 8.5641H18C17.8796 5.93846 16.6118 3.62462 14.6941 2.12308L13.5547 3.29641C15.1755 4.48615 16.2748 6.38974 16.3952 8.5641ZM14.8144 8.97436C14.8144 6.45538 13.4985 4.34667 11.2036 3.78872V3.23077C11.2036 2.54974 10.666 2 10 2C9.334 2 8.79639 2.54974 8.79639 3.23077V3.78872C6.49348 4.34667 5.18556 6.44718 5.18556 8.97436V13.0769L3.58074 14.7179V15.5385H16.4193V14.7179L14.8144 13.0769V8.97436ZM10 18C10.1123 18 10.2167 17.9918 10.321 17.9672C10.8425 17.8523 11.2678 17.4913 11.4764 16.999C11.5567 16.8021 11.5968 16.5887 11.5968 16.359H8.38716C8.39519 17.2615 9.10933 18 10 18Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmset);
export default __webpack_public_path__ + "static/media/icon_alarmset.9fbbd461e5bede79ec3b8bf4786f3291.svg";
export { ForwardRef as ReactComponent };